// 地图的key
export const MAP_DEFAULT_ZOOM = 15; // 地图默认缩放级别 - [2 - 20]

export const ROLE_OPERATE = "useradmin"; // 操作权限